import { useTranslation } from 'react-i18next';

export const DEFAULT_USER_MODULES = {
  assessments: true,
  crm: false,
  university: false,
} as const;

export type ModuleId = keyof typeof DEFAULT_USER_MODULES;

export interface ModuleInfo {
  id: ModuleId;
  label: string;
  description: string;
}

export const useModules = (): Record<ModuleId, ModuleInfo> => {
  const { t } = useTranslation();

  return {
    assessments: {
      id: 'assessments',
      label: t('modules.assessments.label'),
      description: t('modules.assessments.description'),
    },
    crm: {
      id: 'crm',
      label: t('modules.crm.label'),
      description: t('modules.crm.description'),
    },
    university: {
      id: 'university',
      label: t('modules.university.label'),
      description: t('modules.university.description'),
    },
  };
};